<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/signaletique
</style>

<template>
    <Zone
        :id="data.id"
        :dataLabel="data.dataLabel"
        :contrast="contrast"
        class="g_signaletique"
        :class="[path === 'signaletique-interieure' ? 'g_si' : 'g_se']"
        autoHeight>
        <Heading
            :level="2"
            v-html="data.title" />
        <Paragraph
            :content="data.subtitle"
            size="XL" />
        <Cta
            v-if="link1"
            type="text"
            class="g_btn g_btnBuy g_btnDevis"
            :link="link1.link"
            target="_self"
            fontIcon="fn_download"
            :content="link1.cta" />
        <div class="g_row">
            <div v-for="(swiper, i) of data.swipers" :key="i">
                <div>
                    <Heading
                        :level="3"
                        v-html="swiper.title"/>
                </div>
                <Swiper
                    :swiperOption="swiperOption"
                    :showButtonsOnMobile="true">
                    <Slide
                        v-for="(photo, j) of swiper.list"
                        :key="j">
                        <div class="g_slideContent">
                            <div
                                class="g_image"
                                v-img-src="{ folder: path, name: 'swiper'+(i+1)+'-'+(j+1), suffix: false }" />
                            <Paragraph
                                size="L"
                                v-html="photo.title"/>
                            <Paragraph
                                v-if="photo.content"
                                size="M"
                                v-html="photo.content"/>
                            <div
                                v-if="photo.image"
                                class="g_imageDetail"
                                v-img-src="{ folder: path, name: photo.image, suffix: false }" />
                        </div>
                    </Slide>
                </Swiper>
            </div>
        </div>
        <Cta
            v-if="link2"
            type="text"
            class="g_btn g_btnBuy g_btnDevis"
            :link="link2.link"
            target="_self"
            fontIcon="fn_download"
            :content="link2.cta" />
    </Zone>
</template>

<script>
import Swiper from 'gvue/src/core/Swiper'
import Slide from 'components/swiper/Slide'

export default {
    name: 'Signaletique',
    components: {
        Swiper,
        Slide
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        link1: {
            type: Object,
            required: false
        },
        link2: {
            type: Object,
            required: false
        },
        contrast: {
            type: String,
            default: 'dark'
        },
        path: {
            type: String,
            default: 'signaletique-interieure'
        }
    },
    computed: {
        swiperOption () {
            const defaultSwiperOption = {
                // nextTick is a component's own property, and if nextTick is set to true, the component will not instantiate the swiper through nextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
                nextTick: true,
                slideToClickedSlide: this.$breakpoint.isS,
                slidesPerView: 1,
                initialSlide: 0,
                virtualTranslate: this.$touch,
                prevButton: `.swiper-button-prev`,
                nextButton: `.swiper-button-next`
            }

            // Add pagination
            defaultSwiperOption.pagination = `.swiper-pagination`
            defaultSwiperOption.paginationClickable = true
            defaultSwiperOption.paginationBulletRender = function (swiper, index, className) {
                return swiper.isBeginning && swiper.isEnd ? ''
                    : '<button class="' + className + '"><span>' + (index + 1) + '</span></button>'
            }

            return defaultSwiperOption
        }
    }
}
</script>
